@use 'styles/colors' as *;
@use 'styles/functions/rem' as *;
@use 'styles/mixins/shadows' as *;

.optionsButton {
    height: 100%;
    position: relative;
    width: 100%;
}
